import QuestionIcon from '../Icon/QuestionIcon';
import './HintTooltip.css';

/**
 * "?" das dicas que abrem em modal (conteúdo longo, com exemplos), com o mesmo visual do
 * HintTooltip. Antes esses ícones ficavam dentro de um <Link>, e o CSS global do template
 * pinta todo link em hover de quase preto: no tema escuro o ícone sumia ao passar o mouse.
 */
const HintModalTrigger = ({ onClick, label = 'Ver dica' }) => {

    // Enter e espaço abrem a dica pelo teclado, como num botão.
    function handleKeyDown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick();
        }
    }

    return (
        <span
            className="hint-popover__trigger"
            role="button"
            tabIndex={0}
            aria-label={label}
            onClick={onClick}
            onKeyDown={handleKeyDown}
        >
            <QuestionIcon />
        </span>
    );
};

export default HintModalTrigger;
